import HeaderDashboard from './header-dashboard';
import SidebarDashboard from './sidebar-dashboard';
import { Outlet, useLocation } from 'react-router';
import { CloseIcon } from '../../assets/icon/svg';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserId } from '../../features/auth/auth-slice';
import getFullName from '../../hooks/common/use-fullname';
import { useDynamicQuires } from '../../hooks/services/dynamic-queries/use-dynamic-quires';
import { selectCollapsed, selectMobileSidebar, selectOpenMenu, setBooleanValue, setStringValue } from '../../features/dashboard/dashboard-slice';
import { useEffect } from 'react';

export default function ContainerDashboard() {
    
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const { userData } = useDynamicQuires({ currentId: userId! });
    const collapsed = useSelector(selectCollapsed);
    const openMenu = useSelector(selectOpenMenu);
    const mobileSidebar = useSelector(selectMobileSidebar);

    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/chats') {
            dispatch(setBooleanValue({ type: 'col', value: true }));
            dispatch(setStringValue({ type: 'om', value: null }));
        }
    }, [location.pathname, dispatch]);
    
    const userName = getFullName({
        firstName: userData?.firstname,
        lastName: userData?.lastname,
        middleName: userData?.middlename,
        suffix: userData?.suffix,
    });

    const toggleMenu = (label: string) => {
        if (collapsed) return;
        dispatch(setStringValue({type: 'om', value: openMenu === label ? null : label}))
    };

    return (
        <div className="flex h-screen w-full flex-col overflow-hidden bg-[#f5f9fd]">
            <HeaderDashboard 
                collapsed={collapsed} 
                setCollapsed={(value) => dispatch(setBooleanValue({type: 'col', value}))} 
                setMobileSidebar={(value) => dispatch(setBooleanValue({type: 'ms', value}))} 
            />
            <div className="flex min-h-0 flex-1 overflow-hidden">
                <SidebarDashboard 
                    userData={userData} 
                    setCollapsed={(value) => dispatch(setBooleanValue({type: 'col', value}))} 
                    collapsed={collapsed} 
                    toggleMenu={toggleMenu} 
                    openMenu={openMenu} 
                    setOpenMenu={(value) => dispatch(setStringValue({type: 'om', value}))} 
                    className="hidden md:flex" 
                />

                {mobileSidebar && (
                    <div 
                        onClick={() => dispatch(setBooleanValue({type: 'ms', value: false}))} 
                        className="fixed inset-0 z-50 bg-black/40 backdrop-blur-[2px] md:hidden"
                    >
                        <div onClick={(e) => e.stopPropagation()} className="flex h-full w-full max-w-[280px] flex-col bg-white shadow-2xl">
                            <div className="flex h-14 flex-shrink-0 items-center justify-between bg-[#186cb2] px-4 text-white">
                                <div className="flex min-w-0 items-center gap-3">
                                    <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-white/15 text-xs font-bold uppercase">{userName?.charAt(0) ?? 'U'}</div>
                                    <h1 className="truncate text-sm font-semibold">{userName}</h1>
                                </div>
                                <button 
                                    type="button" 
                                    onClick={() => dispatch(setBooleanValue({type: 'ms', value: false}))} 
                                    className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 text-white transition hover:bg-white/20"
                                >
                                    <CloseIcon />
                                </button>
                            </div>
                            <SidebarDashboard 
                                userData={userData} 
                                collapsed={false} 
                                toggleMenu={toggleMenu} 
                                openMenu={openMenu} 
                                setOpenMenu={(value) => dispatch(setStringValue({type: 'om', value}))} 
                                setMobileSidebar={(value) => dispatch(setBooleanValue({type: 'ms', value}))} 
                                mobileSidebar={mobileSidebar} 
                                className="h-full w-full" 
                            />
                        </div>
                    </div>
                )}

                <main className="flex min-w-0 flex-1 flex-col overflow-hidden bg-[#f5f9fd] p-2 sm:p-3">
                    <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl bg-white shadow-sm">
                        <Outlet />
                    </div>
                </main>
                {/* <main className="flex min-w-0 min-h-0 flex-1 flex-col overflow-y-auto bg-[#f5f9fd] p-2 sm:p-3">
                    <div className="flex w-full min-w-0 shrink-0 flex-col rounded-xl">
                        <Outlet />
                    </div>
                </main> */}
            </div>
        </div>
    );
}